import Vue from 'vue'
import * as Sentry from "@sentry/vue"

Sentry.init({
  Vue,
  dsn: 'https://1867814223784afe83b6ee72ea777b37@sentry.io/1312991',
  integrations: []
})
